import { NavigationManager } from "./navigation.js";
import { ChatApp } from "./chat.js";
import { GameshowApp } from "./gameshow.js";
import { VersusApp } from "./versus.js";
import { NotesApp } from "./notes.js";
import { PongApp } from "./pong.js";
import { MurdndApp } from "./murdnd.js";

// Global instances
let app: ChatApp;
let nav: NavigationManager;
let gameshow: GameshowApp;
let versus: VersusApp;
let notes: NotesApp;
let pong: PongApp;
let murdnd: MurdndApp;

document.addEventListener("DOMContentLoaded", () => {
  // Initialize navigation
  nav = new NavigationManager();
  
  // Initialize notes/about page
  notes = new NotesApp();
  notes.setNavigationManager(nav);
  nav.registerExperiment("notes", notes);
  
  // Initialize chat app for Safety Q&A
  app = new ChatApp();
  nav.registerExperiment("safety-qa", app);
  // Make app available globally for compatibility
  (window as any).app = app;
  
  // Initialize gameshow
  gameshow = new GameshowApp();
  nav.registerExperiment("gameshow", gameshow);
  (window as any).gameshow = gameshow;
  
  // Initialize versus game
  versus = new VersusApp();
  nav.registerExperiment("versus", versus);
  (window as any).versus = versus;
  
  // Initialize pong game
  pong = new PongApp();
  nav.registerExperiment("pong", pong);
  (window as any).pong = pong;
  
  // Initialize MURD&D game
  murdnd = new MurdndApp();
  nav.registerExperiment("murdnd", murdnd);
  (window as any).murdnd = murdnd;

  // When LLM is ready, share it with gameshow, versus, pong, and murdnd
  const checkLLM = setInterval(() => {
    if (app.llm) {
      gameshow.init(app.llm);
      versus.init(app.llm);
      pong.init(app.llm);
      murdnd.init(app.llm);
      clearInterval(checkLLM);
    }
  }, 100);

  // Add debug helper to clear cache (accessible via console)
  (window as any).clearModelCache = async () => {
    await app.clearModelCache();
  };

  console.log(
    "💾 Cache Management: Type clearModelCache() in console to clear the cached model"
  );
});